<div class="container mt-4">

  <ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()" class="sticky-top" style="top: 10px;">{{ alert.message }}</ngb-alert>

  <div class="row mb-3">
    <div class="col-12">
      <h1> Reported sighting of {{ missingPetReport.pet.name }}</h1>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-12">
      <div ngbAccordion>
        <div ngbAccordionItem="first" #first="ngbAccordionItem" id="last-seen-map" [collapsed]="!startMapOpened" >
          <div ngbAccordionHeader>
            <div class="card border-0">
              <div class="card-header">
                <div class="row">
                  <div class="col-sm-8">
                    <h4 class="mb-2 mt-2">Location of sighting:</h4>
                  </div>
                  <div class="col-sm-4 text-end">
                    <button
                      ngbAccordionToggle
                      class="btn btn-sm mt-1"
                      [class]="{ 'btn-outline-secondary' : first.collapsed, 'btn-light': !first.collapsed }">
                      {{ !first.collapsed ? 'Hide' : 'See' }} map
                      <fa-icon [icon]="['fas', !first.collapsed ? 'caret-up' : 'caret-down']"></fa-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <google-map
                [zoom]="lastSeenMapLocation.lat && lastSeenMapLocation.lng ? 14 : 5"
                [center]="{
                  lat: lastSeenMapLocation.lat,
                  lng: lastSeenMapLocation.lng,
                }"
                [options]="{
                  disableDefaultUI: true,
                  zoomControl: false,
                  cameraControl: true,
                  scrollwheel: false,
                  clickableIcons: false,
                  fullscreenControl: true,
                  draggableCursor: 'default'
                }"
                width="100%"
              >
                  <map-marker
                  *ngFor="let marker of missingPetReport.seenLocations"
                  [position]="{ lat: marker.location.latitude, lng: marker.location.longitude}"
                  [options]="{ draggable: false }"
                  >
                  </map-marker>
                  <map-circle
                  *ngFor="let marker of missingPetReport.seenLocations"
                  [center]="{
                    lat: marker.location.latitude,
                    lng: marker.location.longitude
                  }"
                  [radius]="250"
                  [options]="{
                    fillColor: '#ee7203',
                    strokeColor: '#ee7203',
                    strokeWeight: 1,
                    clickable: false
                  }"
                >
                </map-circle>
                <map-circle
                  *ngIf="missingPetReport.lastSeen.location.latitude && missingPetReport.lastSeen.location.longitude"
                  [center]="{
                    lat: missingPetReport.lastSeen.location.latitude,
                    lng: missingPetReport.lastSeen.location.longitude
                  }"
                  [radius]="250"
                  [options]="{
                    fillColor: '#ee7203',
                    strokeColor: '#ee7203',
                    strokeWeight: 1,
                    clickable: false
                  }"
                >
                </map-circle>
              </google-map>
              
              </ng-template>
            </div>
          </div>
          <div ngbAccordionFooter>
            <div class="card border-0">
              <div class="card-header">
                <div class="row">
                  <div class="col-sm-8">
                    <h4 class="mb-2 mt-2">Details: </h4>
                    <div class="date-time-content">
                      <h5><b>Date: </b>{{ lastSeenDate | date: 'd MMMM y' }}</h5>
                      <h5><b>Time: </b>{{ lastSeenDate | date: 'HH:mm' }}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-5">
    <div class="text-center">
      <h5>If you need further assistance, please call our team on 03309 128 001</h5>
    </div>
  </div>
  <div class="row mt-5">
    <div class="d-flex justify-content-center">
      <button
      type="button"
      class="btn btn-brand-orange btn-lg text-white position-relative bottom-button mt-1"
      (click)="closeListing()"
      >
        <img
        class="button-with-pawn"
        src="/assets/images/identibase/whitepawlarge.png"
        />
        Close report
      </button>
    </div>
  </div>
  <hr class="my-4">

</div>
